import { PeekStack, PeekTypography } from '@piiqtechnologies/ui-components';
import React from 'react';
import '@piiqtechnologies/svg-icons';
import { ViewerRooms } from '../../../../components/viewer-navigation-menu/ViewerRooms.js';

const RoomsDetails = ({ onRoomSelect }) => {
    return (React.createElement(PeekStack, { spacing: 2, overflow: "auto" },
        React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightBold" }, "All Rooms"),
        React.createElement(PeekStack, { flexGrow: 1, overflow: "auto", width: { md: 330 }, sx: { scrollbarWidth: "auto" } },
            React.createElement(ViewerRooms, { onRoomSelect: onRoomSelect }))));
};

export { RoomsDetails, RoomsDetails as default };
